// eslint-disable-next-line jtag-missing-key,no-restricted-imports
import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";

export const DetailItem = styled.div`
  margin-bottom: 1rem;

  strong {
    color: ${color("text-dark")};
    display: inline-block;
    width: 140px;
  }
`;

export const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
